import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isAnyHovered: false,
  hoveredColor: ''
};

const floatDotSlicer = createSlice({
  name: 'floatDot',
  initialState,
  reducers: {
    setIsAnyHovered: (state, action) => {
      state.isAnyHovered = action.payload;
    },
    setHoveredColor: (state, action) => {
      state.hoveredColor = action.payload;
    }
  },
  reset : () => initialState
});

export const { setIsAnyHovered, setHoveredColor } = floatDotSlicer.actions;
export default floatDotSlicer.reducer;

